import ru from 'utils/plural/langs/ru';
import ua from 'utils/plural/langs/ua';
import en from 'utils/plural/langs/en';
import by from 'utils/plural/langs/by';
import lv from 'utils/plural/langs/lv';
import lt from 'utils/plural/langs/lt';
import ee from 'utils/plural/langs/ee';
import ge from 'utils/plural/langs/ge';
import az from 'utils/plural/langs/az';
import ro from 'utils/plural/langs/ro';
import kg from 'utils/plural/langs/kg';
import kz from 'utils/plural/langs/kz';

export default {
  ru,
  ua,
  en,
  by,
  lv,
  lt,
  ee,
  ge,
  az,
  ro,
  kg,
  kz,
}
